import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 从 localStorage 读取上次设置的语言，默认为中文
const savedLocale = localStorage.getItem('locale') || 'zh'

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'zh',
  messages: {
    zh,
    en,
  },
  silentTranslationWarn: true,
})

export default i18n
